import { Navigation } from "lucide-react";
import { kmh, localTime, wIcon } from "@/lib/weather";
import { useT } from "@/lib/i18n";

export const HourlyStrip = ({ data }) => {
  const { t } = useT();
  const hours = (data.hourly || []).slice(0, 24);
  return (
    <section data-testid="weather-hourly" className="bg-[#12141C] border border-[#282D3D] rounded-sm p-4">
      <div className="font-mono text-[11px] uppercase tracking-widest text-slate-400 mb-2">{t("wx_next_24h")}</div>
      <div className="flex gap-1.5 overflow-x-auto pb-1">
        {hours.map((h, i) => {
          const Icon = wIcon(h.weather?.[0]?.icon);
          const pop = Math.round((h.pop || 0) * 100);
          const rain = (h.rain?.["1h"] || 0) + (h.snow?.["1h"] || 0);
          return (
            <div key={h.dt} data-testid={`weather-hour-${i}`} className={`shrink-0 w-[88px] rounded-sm border px-2 py-2.5 text-center ${pop >= 50 ? "border-[#007AFF]/60 bg-[#007AFF]/10" : "border-[#282D3D] bg-[#0B0D13]"}`}>
              <div className="font-mono text-xs text-slate-300">{i === 0 ? t("wx_now_short") : localTime(h.dt, data.timezone_offset, { hour: "2-digit" })}</div>
              <Icon className="w-7 h-7 mx-auto my-1 text-[#FFB800]" />
              <div className="font-heading font-bold text-2xl tabular-nums">{Math.round(h.temp)}°</div>
              <div className={`font-mono text-sm font-bold ${pop >= 30 ? "text-[#60A5FA]" : "text-slate-500"}`}>{pop}%</div>
              <div className="font-mono text-[11px] text-slate-400">{rain > 0 ? `${rain.toFixed(1)}mm` : "—"}</div>
              <div className="flex items-center justify-center gap-0.5 font-mono text-[11px] text-slate-300 mt-0.5">
                <Navigation className="w-3 h-3" style={{ transform: `rotate(${(h.wind_deg || 0) + 135}deg)` }} />{kmh(h.wind_speed)}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};
